import sanitizeHtmlFilter from './sanitizeHtml.filter'

export default (str) => {
  return str ? sanitizeHtmlFilter(str.replace(/\n/g, '<br>').replace(/\t/g, '&nbsp;&nbsp;')) : null
}
